import { ReactNode, useEffect, useRef, useState } from "react"
import { useSpring, animated } from "@react-spring/web";

interface Props {
  children: ReactNode
  show: boolean
  fade?: boolean
}

/**
 * Animated expandable container
 *
 * @param show Set `true` when contents need to be shown
 */
export function ExpandableContainer({
  children,
  show,
  fade,
}: Props) {
  const container = useRef<HTMLDivElement>(null)
  const [contentHeight, setContentHeight] = useState(0)
  useEffect(() => {
    const observer = new ResizeObserver(entries => {
      setContentHeight(entries[0].contentRect.height)
    })
    if(container.current) {
      observer.observe(container.current)
    }
    return () => observer.disconnect()
  }, [])

  const animationStyles = useSpring({
    height: show ? contentHeight : 0,
    opacity: show ? 1 : fade ? 0 : 1,
  });

  return <animated.div
    style={{...animationStyles, overflow: "hidden"}}
  >
    <div ref={container}>
      {children}
    </div>
  </animated.div>
}